/**
 * Ad set and ad attribution — the two levels below a campaign.
 *
 * Every `*Label` comes from the backend's platform adapter, so the console
 * never maps a platform to a name itself.
 */
export enum AdLevel {
  Campaign = "CAMPAIGN",
  AdSet = "AD_SET",
  Ad = "AD",
}

/** One ad set or ad under its parent, with the campaigns list's columns. */
export interface AdLevelMetric {
  id: string;
  name: string;
  level: AdLevel;
  externalId: string;
  externalStatus: string | null;
  isDelivering: boolean;
  /** Set once the provider stopped listing the object. Row stays visible. */
  staleAt: string | null;
  parentId: string | null;
  /** Ads under an ad set — whether the row can expand. */
  childCount: number;
  /** Lifetime provider spend; null means never synced, not $0. */
  spendCents: number | null;
  opportunityCount: number;
  convertedCount: number;
  revenueCents: number;
  cpaCents: number | null;
  roiPercent: number | null;
}

export interface AdLevelMetrics {
  level: AdLevel;
  /** "Ad set" on Meta, "Ad group" on Google. */
  levelLabel: string;
  rows: AdLevelMetric[];
}

export interface AdHierarchySyncResult {
  campaignId: string;
  adSetsSeen: number;
  adsSeen: number;
  adSetsStopped: number;
  adsStopped: number;
  touchpointsResolved: number;
  skippedReason: string | null;
}

export interface AdRoutingNode {
  id: string;
  name: string;
  level: AdLevel;
  levelLabel: string;
  /** The ad set an ad sits under; null on an ad set. */
  parentId: string | null;
  pipelineId: string | null;
  effectivePipelineId: string | null;
  effectivePipelineName: string | null;
  /** The level that supplied the pipeline used; null when this level's own is. */
  inheritedFrom: AdLevel | null;
}
